<template>
    <div class="table-box">
        <UploadButton :fileList="fileList" @upload_success="upload_success" :title="btn_name" :dir="dir" :disabled="disabled" :accept="accept" :max_size="max_size"></UploadButton>
        <div class="tips"><slot></slot></div>
        <div class="img-box" v-if="fileList.length > 0">
            <!-- 图片列表：不传 height 时仅按 width 显示，高度随图片比例自适应 -->
             <div class="img-item" v-for="(item, index) in fileList" :key="index" :class="{ 'img-item-auto-height': isAutoHeight }" :style="itemStyle">
                <el-image class="img-item-img" :style="imgStyle" :src="item.url" :preview-src-list="[item.url]">
                </el-image>
                <i class="el-icon-close icon-dd" @click="del_pic(index)"></i>
             </div>
        </div>
    </div>
</template>
<script>
    import UploadButton from './UploadButton.vue';
    export default {
        name: "UploadPicture",
        components: {
            UploadButton
        },
        props: {
            fileList: {                     // 图片列表
                type: Array,
                default: []
            },
            width: {                        // 图片宽度
                type: [Number, String],
                default: 100
            },
            height: {                       // 图片高度，不传或传 0 时按宽度自适应高度
                type: [Number, String],
                default: null
            },
            dir: {                          // 上传图片的目录
                type: String,
                default: 'admin'
            },
            max_limit: {                    // 最大上传数量
                type: [Number, String],
                default: 1
            },
            accept: {                       // 上传文件类型
                type: String,
                default: '.jpg,.png,.jpeg'
            },
            max_size: {                     // 上传文件大小
                type: [Number, String],
                default: 1024
            }
        },
        data() {
            return {
                btn_name: '上传图片',
                disabled: false
            }
        },
        computed: {
            isAutoHeight() {
                const h = this.height;
                return h === null || h === undefined || h === '' || Number(h) === 0;
            },
            itemStyle() {
                const w = Number(this.width) / 2 + 'px';
                if (this.isAutoHeight) {
                    return { width: w };
                }
                return { width: w, height: Number(this.height) / 2 + 'px' };
            },
            imgStyle() {
                const w = Number(this.width) / 2 + 'px';
                if (this.isAutoHeight) {
                    return { width: w, height: 'auto', display: 'block' };
                }
                return { width: w, height: Number(this.height) / 2 + 'px' };
            }
        },
        watch: {
            fileList: {
                handler(val) {
                    if (val.length >= this.max_limit) {
                        this.disabled = true
                    } else {
                        this.disabled = false;
                    }
                },
                deep: true,                     // 深度监听
                immediate: true                 // 立即执行  也就是页面加载的时候执行 也就是页面加载的时候执行
            }
        },
        methods: {
            // 上传成功
            upload_success(res) {
                this.fileList.push(res)
                this.$emit('update:fileList', this.fileList)
            },

            // 删除图片
            del_pic(index) {
                this.fileList.splice(index, 1)
                this.$emit('update:fileList', this.fileList)
            },

            // 批量操作
            batch_ids(val) {
                this.$emit('batch_ids', val)
            }
        }
    }
</script>
<style scoped>
    .table-box {
        display: block;
    }
    .tips {
        font-size: 12px;
        line-height: 20px;
        color: #606266;
    }
    .table-box .img-box {
        display: flex;
        flex-wrap: wrap;
        margin-top: 10px;
        gap: 10px;
        background-color: #f8f8f8;
        padding: 10px;
        border-radius: 5px;
    }
    .table-box .img-box .img-item {
        position: relative;
        border-radius: 3px;
    }
    .table-box .img-box .img-item.img-item-auto-height {
        height: auto;
    }
    .table-box .img-box .img-item .img-item-img {
        border-radius: 5px;
    }
    .table-box .img-box .img-item:hover .icon-dd {
        display: block;
    }
    .table-box .img-box .img-item .icon-dd {
        display: none;
        font-size: 18px;
        color: #5c9df8;
        position: absolute;
        right: 2px;
        top: 2px;
        z-index: 9;
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/UploadPicture.vue